import type { SearchTourStep } from './searchTourSteps';

export const ADVANCED_SEARCH_TOUR_STEPS: SearchTourStep[] = [
  {
    id: 'tabs',
    title: 'Choose identifier type',
    body: 'Use the entity tabs (Diseases, Variants, Genes, Chemicals). The UI and expected identifiers change accordingly.',
    selector: '[data-demo-tour="advanced-search-tabs"]',
    prepare: ['advanced-search-back-to-input'],
  },
  {
    id: 'input',
    title: 'Add your search list',
    body: 'Paste one identifier per line. Then you can resolve the list into matches.',
    selector: '[data-demo-tour="advanced-search-input-textarea"]',
    prepare: ['advanced-search-back-to-input'],
  },
  {
    id: 'show-examples',
    title: 'Show examples',
    body: '“Show Examples” loads a ready-to-run identifier list into the input. The tour fills it for you so you can continue.',
    // After prepare clicks Show Examples, that button unmounts — spotlight the filled textarea instead.
    selector: '[data-demo-tour="advanced-search-input-textarea"]',
    prepare: ['advanced-search-back-to-input', 'advanced-search-show-examples'],
  },
  {
    id: 'results-example',
    title: 'Review example results',
    body: 'Now the matches/results table is shown. Review what was found, starting from the first selectable row.',
    selector: '[data-demo-tour="advanced-search-row-checkbox"]',
    fallbackSelector: '[data-demo-tour="advanced-search-search-list"], #advanced_search_search_list',
    prepare: ['advanced-search-run-search-list'],
    note: 'If the table is not visible yet, the “Search List” action may need to be triggered first.',
  },
  {
    id: 'select',
    title: 'Select results (all or rows)',
    body: 'Select rows using “Select All” or click individual checkboxes.',
    selector: '[data-demo-tour="advanced-search-select-all"]',
    fallbackSelector: '[data-demo-tour="advanced-search-row-checkbox"]',
  },
  {
    id: 'search-selected',
    title: 'Search selected items',
    body: 'Click “Search Selected Items” to run Search with your selected resolved identifiers.',
    selector: '[data-demo-tour="advanced-search-search-selected"]',
    fallbackSelector: '[id="advanced_search_search_selected"]',
    note: 'If you are working on Variants, you may also jump to Enrichment using “Enrichment Analysis”.',
  },
];
